import { useEffect, useState } from "react";

import { getAuth, subscribe, type AuthState } from "@/api/auth-store";

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>(getAuth);
  useEffect(() => subscribe(setState), []);
  return state;
}
